// NGC Flow slot default values
// These values are used when the Monarch slot doesn't provide data
// Note: useMonarchSlot extracts the component's `data` property,
// so we receive the config values directly (flat structure)
export type NgcFlowSlotData = {
  ngcFlow: 'v1' | 'v2' | 'v3' | 'v4';
  model: 'ml' | 'revenue_ml';
  showFaq: boolean;
  showMoreDetailsByop: boolean;
  altProductExplainerVersion: 'v2' | 'v3';
  v2AddOnCheckbox: boolean;
  claimRewardsLocation: 'default' | 'header';
  enableStickyCtaOnQuiz: boolean,
};

export const ngcFlowDefaultValue: NgcFlowSlotData = {
  ngcFlow: 'v2',
  model: 'ml',
  showFaq: false,
  showMoreDetailsByop: true,
  altProductExplainerVersion: 'v2',
  v2AddOnCheckbox: false,
  claimRewardsLocation: 'default',
  enableStickyCtaOnQuiz: false,
};
